import { loggerFacet, IMeasurementInfo, internalPerfLoggerKeyFacet, internalPerfLoggerFacet } from '../facets/LoggerFacets';
import { IItemCacheThunkAction, IItemCacheDispatch, IItemCacheContext } from '../store/actions/ItemCacheActions';
import { IItemCacheState } from '../store/reducers/itemCacheReducer';
import { unpack } from '../models/Facet';
import { readItems } from './readItems';
import { IItemCache } from '../models/IItemCacheObserver';

/**
 * Uses logger provided in the configuration, if any, to log when the component finishes rendering
 * @internal
 */
export function logPageLoad(timestamp: number, measurementInfo?: IMeasurementInfo): IItemCacheThunkAction<void> {
    return (dispatch: IItemCacheDispatch, getState: () => IItemCacheState, context: IItemCacheContext) => {

        if (timestamp && context && context.configuration) {
            const internalPerfLoggerKey = internalPerfLoggerKeyFacet.serialize({});
            const internalLogger = dispatch(readItems((itemCache: IItemCache) => {
                return itemCache.demandItemFacet(internalPerfLoggerFacet, internalPerfLoggerKey);
            }));
            if (internalLogger) {
                internalLogger(timestamp, measurementInfo);
            }
            const { logger } = unpack({
                logger: loggerFacet
            }, context.configuration);

            if (logger && logger.logRenderEndTime) {
                logger.logRenderEndTime(timestamp, measurementInfo);
            }
        }
    };
}
